import { getFunctions, httpsCallable } from 'firebase/functions';
import app from '../firebase';

const functions = getFunctions(app, 'europe-west1');
const submitContactRequest = httpsCallable(functions, 'submitContactRequest');

export const sendContactRequest = async (payload) => {
  const result = await submitContactRequest(payload);
  return result.data;
};
